/**
 * Add-on registry. Definitions live in code; per-tenant enabled state lives in
 * Firestore `config/addons` ({ [key]: { enabled, tier, enabledAt, enabledBy, ... } }).
 *
 * Client-side gating is cosmetic. Cloud Functions must call assertAddon()
 * (functions/utils/addons.js) before doing add-on work.
 */

export const ADDONS = {
  AI_SALES_AGENT: 'aiSalesAgent',
  AI_SALES_AGENT_PAID: 'aiSalesAgentPaid'
};

export const ADDON_CATALOG = [
  {
    key: ADDONS.AI_SALES_AGENT,
    name: 'AI Sales Agent',
    description:
      'Rules-based customer health insights, next-step recommendations, and personal/team recommendations queues. Paid AI summaries are controlled by the separate add-on below.',
    docs: 'DOCS/AI_SALES_AGENT_DESIGN.md'
  },
  {
    key: ADDONS.AI_SALES_AGENT_PAID,
    name: 'AI Sales Agent - Paid AI summaries',
    description:
      'Paid, on-demand summaries and talking points for all customers the requesting user may access. Requires the AI Sales Agent add-on; rules-only recommendations remain available when this is off.',
    docs: 'DOCS/AI_SALES_AGENT_DESIGN.md'
  }
];

export function isAddonEnabled(addonsDoc, key) {
  return addonsDoc?.[key]?.enabled === true;
}

export function getPaidAiActivationError(settings, pricing, baseEnabled) {
  if (!baseEnabled) return 'Enable the AI Sales Agent add-on first.';
  if (!settings || !pricing) return 'Loading paid AI configuration...';
  const model = typeof settings.defaultModel === 'string' ? settings.defaultModel.trim() : '';
  if (!model) return 'Configure the paid AI model before enabling summaries.';
  const price = pricing.models?.[model] || pricing[model];
  if (!price || ['inputPerMTok', 'outputPerMTok'].some(
    key => !Number.isFinite(Number(price[key])) || Number(price[key]) < 0
  )) return 'Configure valid input and output pricing for the selected model first.';
  if (['monthlyBudgetUsd', 'dailyTokenCap', 'maxOutputTokens', 'onDemandPerUserPerHour'].some(
    key => !Number.isFinite(Number(settings[key])) || Number(settings[key]) <= 0
  ) || Number(settings.maxOutputTokens) < 1) {
    return 'Configure positive monthly, daily-token, output-token, and hourly refresh limits first.';
  }
  return null;
}
